import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from '../forms/RecordForm';
import {SubscriptionItem} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: SubscriptionItem,
        handleSubmit: (values: SubscriptionItem) => void | Promise<unknown>
    }) => {

    const title = record?.id ? 'Edit Subscription Item' : 'Add Subscription Item';

    /**
     * FNP-918: AWAIT the mutation BEFORE closing, and close only on SUCCESS
     * (§7).
     *
     * The await was already here, but `handleSubmit` was `mutate` — which
     * returns void — so it resolved on the same tick and closed the drawer
     * before the server answered. It is now `mutateAsync` (see
     * useSubscriptionItem).
     *
     * Staying open on a server error preserves the operator's input; the error
     * itself is surfaced by the mutation's onError notification.
     */
    const handleFormSubmit = async (values: SubscriptionItem) => {
        try {
            await handleSubmit(values);
            onClose();
        } catch {
            // Left open deliberately — the mutation's onError has notified.
        }
    };

    return (
        <Drawer
            transitionProps={{
                transition: 'slide-left',
                duration: 750,
                timingFunction: 'ease'
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    );
};
